export default __webpack_public_path__ + "static/media/sample-plant.31640ee6.jpg";